import Axios from "@/plugins/Axios";

const BASE_URL = "ponto-colaboradores";

export class ColaboradorPontosService {
  async meusPontosDia(params = {}) {
    const response = await Axios().get(`${BASE_URL}/meus-pontos/dia`, { params });
    return response.data;
  }

  async meusPontosUltimos10Dias() {
    const response = await Axios().get(`${BASE_URL}/meus-pontos/ultimos-10-dias`);
    return response.data;
  }

  async meusPontosPeriodo(params = {}) {
    const response = await Axios().get(`${BASE_URL}/meus-pontos/periodo`, { params });
    return response.data;
  }

  async meusPontosPeriodoPdf(params = {}) {
    const response = await Axios().get(`${BASE_URL}/meus-pontos/periodo/pdf`, {
      params,
      responseType: "arraybuffer",
    });
    return this.criarPdfUrl(response.data);
  }

  async listarColaboradores() {
    const response = await Axios().get(`${BASE_URL}/admin/pontos/colaboradores`);
    return response.data;
  }

  async colaboradoresSemBatidaHoje() {
    const response = await Axios().get(`${BASE_URL}/admin/pontos/sem-batida-hoje`);
    return response.data;
  }

  async adminPontosDia(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/pontos/dia`, { params });
    return response.data;
  }

  async adminPontosUltimos10Dias(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/pontos/ultimos-10-dias`, { params });
    return response.data;
  }

  async adminGraficoUltimos10Dias(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/grafico/ultimos-10-dias`, { params });
    return response.data;
  }

  async adminPontosPeriodo(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/pontos/periodo`, { params });
    return response.data;
  }

  async adminPontosPeriodoPdf(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/pontos/periodo/pdf`, {
      params,
      responseType: "arraybuffer",
    });
    return this.criarPdfUrl(response.data);
  }

  async listarMinhasFaltasJustificadas() {
    const response = await Axios().get(`${BASE_URL}/faltas-justificadas`);
    return response.data;
  }

  async enviarFaltaJustificada(formData) {
    const response = await Axios().post(`${BASE_URL}/faltas-justificadas`, formData);
    return response.data;
  }

  async buscarFaltaJustificada(id) {
    const response = await Axios().get(`${BASE_URL}/faltas-justificadas/${id}`);
    return response.data;
  }

  async atualizarMinhaFaltaJustificada(id, formData) {
    formData.append("_method", "PUT");
    const response = await Axios().post(`${BASE_URL}/faltas-justificadas/${id}`, formData);
    return response.data;
  }

  async excluirMinhaFaltaJustificada(id) {
    await Axios().delete(`${BASE_URL}/faltas-justificadas/${id}`);
  }

  async meuDocumentoFalta(id) {
    const response = await Axios().get(`${BASE_URL}/faltas-justificadas/${id}/documento`, {
      responseType: "arraybuffer",
    });
    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const url = window.URL.createObjectURL(blob);
    const novaAba = window.open(url);
    if (!novaAba) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `documento_falta_${id}`;
      link.click();
    }
  }

  async listarTodasFaltasJustificadas(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/faltas-justificadas`, { params });
    return response.data;
  }

  async listarFaltasJustificadasPendentes() {
    const response = await Axios().get(`${BASE_URL}/admin/faltas-justificadas/pendentes`);
    return response.data;
  }

  async abrirDocumentoFalta(id) {
    const response = await Axios().get(`${BASE_URL}/admin/faltas-justificadas/${id}/documento`, {
      responseType: "arraybuffer",
    });
    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const url = window.URL.createObjectURL(blob);
    const novaAba = window.open(url);
    if (!novaAba) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `documento_falta_${id}`;
      link.click();
    }
  }

  async avaliarFaltaJustificada(id, dados) {
    const response = await Axios().put(
      `${BASE_URL}/admin/faltas-justificadas/${id}/avaliar`,
      dados
    );
    return response.data;
  }

  async ajustarPonto(dados) {
    const response = await Axios().post(`${BASE_URL}/admin/ajustes`, dados);
    return response.data;
  }

  async listarHistoricoAjustes(instrutorId) {
    const response = await Axios().get(`${BASE_URL}/admin/ajustes/${instrutorId}/historico`);
    return response.data;
  }

  async listarFeriados() {
    const response = await Axios().get(`${BASE_URL}/admin/feriados`);
    return response.data;
  }

  async cadastrarFeriado(dados) {
    const response = await Axios().post(`${BASE_URL}/admin/feriados`, dados);
    return response.data;
  }

  async atualizarFeriado(id, dados) {
    const response = await Axios().put(`${BASE_URL}/admin/feriados/${id}`, dados);
    return response.data;
  }

  async excluirFeriado(id) {
    await Axios().delete(`${BASE_URL}/admin/feriados/${id}`);
  }

  async previewImportacaoCalendarioLetivo() {
    const response = await Axios().get(`${BASE_URL}/admin/feriados/preview-importacao`);
    return response.data;
  }

  async importarDoCalendarioLetivo(dados) {
    const response = await Axios().post(
      `${BASE_URL}/admin/feriados/importar-calendario-letivo`,
      dados
    );
    return response.data;
  }

  async abrirComprovanteBatida(batidaId) {
    const response = await Axios().get(`${BASE_URL}/colaborador-batidas/${batidaId}/comprovante`, {
      responseType: "arraybuffer",
    });
    const blob = new Blob([response.data], {
      type: response.headers["content-type"] || "application/pdf",
    });
    const url = window.URL.createObjectURL(blob);
    const novaAba = window.open(url);
    if (!novaAba) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `comprovante_batida_${batidaId}.pdf`;
      link.click();
    }
  }

  async criarBatida(dados) {
    const response = await Axios().post(`${BASE_URL}/admin/batidas`, dados);
    return response.data;
  }

  async editarBatida(id, dados) {
    const response = await Axios().put(`${BASE_URL}/admin/batidas/${id}`, dados);
    return response.data;
  }

  async excluirBatida(id, dados) {
    await Axios().delete(`${BASE_URL}/admin/batidas/${id}`, { data: dados });
  }

  async historicoAjustesBatidas(userId) {
    const response = await Axios().get(`${BASE_URL}/admin/batidas/${userId}/historico`);
    return response.data;
  }

  async listarJustificativasMassa() {
    const response = await Axios().get(`${BASE_URL}/admin/justificativas-massa`);
    return response.data;
  }

  async criarJustificativaMassa(dados) {
    const response = await Axios().post(`${BASE_URL}/admin/justificativas-massa`, dados);
    return response.data;
  }

  async buscarJustificativaMassa(id) {
    const response = await Axios().get(`${BASE_URL}/admin/justificativas-massa/${id}`);
    return response.data;
  }

  async atualizarJustificativaMassa(id, dados) {
    const response = await Axios().put(`${BASE_URL}/admin/justificativas-massa/${id}`, dados);
    return response.data;
  }

  async excluirJustificativaMassa(id) {
    await Axios().delete(`${BASE_URL}/admin/justificativas-massa/${id}`);
  }

  async listarMinhasBatidasRemotas() {
    const response = await Axios().get(`${BASE_URL}/batidas-remotas`);
    return response.data;
  }

  async solicitarBatidaRemota(dados) {
    const response = await Axios().post(`${BASE_URL}/batidas-remotas`, dados);
    return response.data;
  }

  async buscarBatidaRemota(id) {
    const response = await Axios().get(`${BASE_URL}/batidas-remotas/${id}`);
    return response.data;
  }

  async adminListarBatidasRemotas(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/batidas-remotas`, { params });
    return response.data;
  }

  async adminAvaliarBatidaRemota(id, dados) {
    const response = await Axios().put(`${BASE_URL}/admin/batidas-remotas/${id}/avaliar`, dados);
    return response.data;
  }

  async colaboradorMaisPontual() {
    const response = await Axios().get(`${BASE_URL}/dashboard/colaborador-mais-pontual`);
    return response.data;
  }

  /** Atrasos sem justificativa dos últimos 30 dias (admin pode informar o colaborador). */
  async listarAtrasosPendentes(colaboradorId = null) {
    const params = colaboradorId ? { colaborador_id: colaboradorId } : {};
    const response = await Axios().get(`${BASE_URL}/atrasos-justificados/pendentes`, { params });
    return response.data;
  }

  async verificarAtrasoPendente(colaboradorId = null) {
    const params = colaboradorId ? { colaborador_id: colaboradorId } : {};
    const response = await Axios().get(`${BASE_URL}/atrasos-justificados/pendente`, { params });
    return response.data;
  }

  async listarMeusAtrasosJustificados() {
    const response = await Axios().get(`${BASE_URL}/atrasos-justificados`);
    return response.data;
  }

  async enviarAtrasoJustificado(formData) {
    const response = await Axios().post(`${BASE_URL}/atrasos-justificados`, formData);
    return response.data;
  }

  async atualizarMeuAtrasoJustificado(id, formData) {
    formData.append("_method", "PUT");
    const response = await Axios().post(`${BASE_URL}/atrasos-justificados/${id}`, formData);
    return response.data;
  }

  async excluirMeuAtrasoJustificado(id) {
    await Axios().delete(`${BASE_URL}/atrasos-justificados/${id}`);
  }

  async abrirMeuAnexoAtraso(id) {
    const response = await Axios().get(`${BASE_URL}/atrasos-justificados/${id}/anexo`, {
      responseType: "arraybuffer",
    });
    const blob = new Blob([response.data], {
      type: response.headers["content-type"] || "application/pdf",
    });
    const url = window.URL.createObjectURL(blob);
    const novaAba = window.open(url);
    if (!novaAba) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `anexo_atraso_${id}`;
      link.click();
    }
  }

  async adminListarAtrasosJustificados(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/atrasos-justificados`, { params });
    return response.data;
  }

  async adminAbrirAnexoAtraso(id) {
    const response = await Axios().get(`${BASE_URL}/admin/atrasos-justificados/${id}/anexo`, {
      responseType: "arraybuffer",
    });
    const blob = new Blob([response.data], {
      type: response.headers["content-type"] || "application/pdf",
    });
    const url = window.URL.createObjectURL(blob);
    const novaAba = window.open(url);
    if (!novaAba) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `anexo_atraso_${id}`;
      link.click();
    }
  }

  async adminAvaliarAtrasoJustificado(id, dados) {
    const response = await Axios().put(
      `${BASE_URL}/admin/atrasos-justificados/${id}/avaliar`,
      dados
    );
    return response.data;
  }

  criarPdfUrl(data) {
    const blob = new Blob([data], { type: "application/pdf" });
    return window.URL.createObjectURL(blob);
  }
}

export default new ColaboradorPontosService();
